var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tweets),function(tweet){return _c('div',{key:tweet.id},[(!tweet.retweetOf)?_c('Tweet',{attrs:{"tweet":tweet}}):_vm._e(),(tweet.retweetOf)?_c('Retweet',{attrs:{"tweet":tweet}}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }